/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsCloudProvider extends models.FilterOptionsCloudProviderLight {
    getFixupPrototypeFunction() { return FilterOptionsCloudProvider.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsCloudProvider>): FilterOptionsCloudProvider {
        let obj = Object.assign(new FilterOptionsCloudProvider(), model);
        FilterOptionsCloudProvider.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsCloudProvider>): FilterOptionsCloudProvider {
        if (!model) return null;
        return FilterOptionsCloudProvider.newInstance(<FilterOptionsCloudProvider> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsCloudProvider) {
        if (!obj) return;

        models.FilterOptionsCloudProvider.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsCloudProvider): boolean {
        if (models.FilterOptionsCloudProviderLight.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FilterOptionsCloudProvider.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.cloud_accounts) {
            for (let val of this.cloud_accounts) {
                models.FilterOptionsCloudAccount.fixupPrototype(val);
            }
        }
    }

    /**
     * List of accounts for this Cloud Provider
     */
    cloud_accounts: Array<models.FilterOptionsCloudAccount>;

}
